import { callCSSFn, CSSFn, styled, StyleProps } from "../styles"
import { PaginationButton } from "../Pagination"

export type LimitBarDataTestIds = {
  root?: string
  option?: string
  button?: string
}

export type LimitBarProps = Readonly<{
  dataTestIds?: LimitBarDataTestIds
  onChange: (value: number) => void
  options: ReadonlyArray<number>
  total?: number
  value: number
  css?: CSSFn
}> &
  Omit<React.ComponentPropsWithRef<"div">, "onChange">

export const LimitBar: React.FC<LimitBarProps> = ({
  dataTestIds,
  onChange,
  options,
  total,
  value,
  ...containerProps
}: LimitBarProps) => {
  if (!total) return null
  return (
    <Container data-testid={dataTestIds?.root} {...containerProps}>
      <PaginationButton
        total={total}
        value={value}
        onChange={onChange}
        options={options}
        dataTestIds={{ listItem: dataTestIds?.option, button: dataTestIds?.button }}
      />
    </Container>
  )
}

const Container = styled.div((props: StyleProps) => ({
  width: `100%`,
  padding: props.theme.spacing(5, 0),
  margin: props.theme.spacing(0, 0, 5, 0),
  borderTop: `.5px solid ${props.theme.palette.grey.dark}`,
  ...callCSSFn(props),
}))
